/** Locale e fuso horário oficiais do site (Brasília = America/Sao_Paulo). */
export const BR_LOCALE = 'pt-BR'
export const BR_TIMEZONE = 'America/Sao_Paulo'
export const BR_OFFSET = '-03:00'

/** Usado só para extrair partes de data via Intl; exibição sempre em pt-BR. */
export const BR_PARTS_LOCALE = 'en-CA'

export function brDateTimeFormatter(options = {}) {
  return new Intl.DateTimeFormat(BR_PARTS_LOCALE, {
    timeZone: BR_TIMEZONE,
    ...options,
  })
}

export function formatBrYear(date = new Date()) {
  return brDateTimeFormatter({ year: 'numeric' }).format(date)
}
